/**
 * FieldValidatorResolver provides a registry for field validators
 * that can be used to validate field values in CMS models.
 */

const fieldValidators = {}

/**
 * Register a field validator
 * @param {string} name - The name of the validator
 * @param {function} validator - The validator function (errors, value, item, params) => void
 */
const addFieldValidator = (name, validator) => {
  fieldValidators[name] = validator
}

/**
 * Get a field validator by name
 * @param {string} name - The name of the validator
 * @returns {function|undefined} The validator function or undefined
 */
const getFieldValidator = (name) => {
  return fieldValidators[name]
}

/**
 * Run validators for a field
 * @param {object} field - The field definition with validators property
 * @param {any} value - The field value to validate
 * @param {object} item - The full item being edited
 * @param {object} errors - The errors object to populate
 * @returns {Promise<void>}
 */
const runFieldValidators = async (field, value, item, errors) => {
  if (!field.validators || typeof field.validators !== 'object') {
    return
  }

  // Run each validator defined in the field
  for (const [validatorName, validatorParams] of Object.entries(field.validators)) {
    const validator = getFieldValidator(validatorName)
    if (validator) {
      try {
        await validator(errors, value, item, validatorParams, field)
      } catch (error) {
        console.error(`Error running validator ${validatorName} for field ${field.id}:`, error)
      }
    } else {
      console.warn(`Validator "${validatorName}" not found for field "${field.id}"`)
    }
  }
}

export { addFieldValidator, getFieldValidator, runFieldValidators }
